import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Kicker } from '@/components/Kicker';

export default function AdminAudit() {
  const { t } = useTranslation();
  const q = useQuery({ queryKey: ['admin', 'audit'], queryFn: async () => (await api.get('/admin/audit')).data });
  const items = q.data?.items || [];
  return (
    <section>
      <Kicker>{t('admin.title')}</Kicker>
      <h1 className="mt-3 font-display text-3xl font-semibold text-[#14171C]">{t('admin.nav.audit')}</h1>
      <div className="mt-8 pn-card overflow-hidden">
        <table className="w-full text-left text-sm" data-testid="admin-audit-table">
          <thead className="bg-[#F6F8FB] text-xs uppercase tracking-wide text-[#4A4D52]">
            <tr>
              <th className="px-4 py-3">{t('admin.audit.time')}</th>
              <th className="px-4 py-3">{t('admin.audit.user')}</th>
              <th className="px-4 py-3">Rolle</th>
              <th className="px-4 py-3">{t('admin.audit.action')}</th>
              <th className="px-4 py-3">{t('admin.audit.meta')}</th>
            </tr>
          </thead>
          <tbody>
            {q.isLoading && <tr><td colSpan={5} className="p-6 text-center text-[#4A4D52]">{t('common.loading')}</td></tr>}
            {items.map((a) => (
              <tr key={a.id} className="border-t border-[#E4E9F0] hover:bg-[#F6F8FB]">
                <td className="px-4 py-3 font-mono text-xs text-[#4A4D52]">{new Date(a.at).toLocaleString()}</td>
                <td className="px-4 py-3">{a.user_email || 'Gast'}</td>
                <td className="px-4 py-3 text-xs">{a.role}</td>
                <td className="px-4 py-3 font-mono text-xs">{a.action}</td>
                <td className="px-4 py-3 font-mono text-[11px] text-[#4A4D52]">{JSON.stringify(a.meta || {})}</td>
              </tr>
            ))}
            {!q.isLoading && items.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-[#4A4D52]">{t('catalog.empty')}</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
